import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// result=0&uin=615628031&msg=2|莪????纟屯1|莪????纟屯2|&_tail_request_body_=cmd|9003||uin|615628031||area|14
// checkparam:'sg|yes|615628031|14|%25DD%25AD%2587%2586%25E6%25F9%25CD%25CD*'
//
// var query_role_result={retCode:0,data:'
// extend=3|615628031|%DD%AD%8Bq%E6%F9%E6%F9%CD%CD|%DD%AD%8BQ%E6%F9%CD%CD|&
// msg=3|615628031|%E8%8E%AA%E5%AA%9E%E7%BA%9F%E7%BA%9F%E5%B1%AF|%E8%8E%AA%E5%A9%B9%E7%BA%9F%E5%B1%AF|&
// result=0&uin=615628031&',msg:'ok',checkparam:'sg|yes|615628031|44|615628031*%25DD%25AD%258Bq%25E6%25F9%25E6%25F9%25CD%25CD*%25DD%25AD%258BQ%25E6%25F9%25CD%25CD*',md5str:'37096787A46FCB0096914A31BF4E7B43'};
import object from '../../../common/object';
export default function (queryRoleResult, request) {
  var checkparam = queryRoleResult.checkparam,
      md5str = queryRoleResult.md5str,
      data = queryRoleResult.data;
  var map = object.unSerialize(data, 1);

  if (map.result) {
    if (map.result * 1 != 0) {
      return {
        iRet: 2,
        // 未查询到角色信息
        sMsg: '查询人数过多，请您稍后再来！',
        arrRole: null
      };
    }
  }

  if (map.msg && map.extend) {
    var arrRoleId = map.extend.split('|');
    var arrRoleName = map.msg.split('|');

    if (arrRoleId.length != arrRoleName.length) {
      return {
        iRet: 3,
        // 未查询到角色信息
        sMsg: '在该服务器上未获取到角色信息！',
        arrRole: null
      };
    }

    var arrRoleList = [];

    for (var i = 1; i < arrRoleName.length; i++) {
      if (arrRoleName[i]) {
        var roleName = arrRoleName[i];

        try {
          roleName = decodeURIComponent(roleName);
        } catch (e) {
          console.log(e);
        }

        arrRoleList.push(_objectSpread(_objectSpread({}, request), {}, {
          roleId: arrRoleId[i],
          roleName: roleName,
          checkparam: checkparam,
          md5str: md5str
        }));
      }
    }

    return {
      iRet: 0,
      // 查询到角色信息
      sMsg: 'OK',
      arrRole: arrRoleList
    };
  }

  return {
    iRet: 3,
    // 未查询到角色信息
    sMsg: '在该服务器上未获取到角色信息！',
    arrRole: null
  };
}